/**
 * Time formatting utilities
 */

/**
 * Format a date to relative time string (Russian)
 * @param {string|Date} date - Date to format
 * @returns {string} Relative time string
 */
export const formatTimeAgo = (date) => {
  if (!date) return '';
  
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  const diffWeek = Math.floor(diffDay / 7);
  const diffMonth = Math.floor(diffDay / 30);
  const diffYear = Math.floor(diffDay / 365);

  if (diffSec < 60) {
    return 'только что';
  }
  
  if (diffMin < 60) {
    return `${diffMin} ${pluralize(diffMin, 'минуту', 'минуты', 'минут')} назад`;
  }
  
  if (diffHour < 24) {
    return `${diffHour} ${pluralize(diffHour, 'час', 'часа', 'часов')} назад`;
  }
  
  if (diffDay < 7) {
    return `${diffDay} ${pluralize(diffDay, 'день', 'дня', 'дней')} назад`;
  }
  
  if (diffWeek < 4) {
    return `${diffWeek} ${pluralize(diffWeek, 'неделю', 'недели', 'недель')} назад`;
  }
  
  if (diffMonth < 12) {
    return `${diffMonth} ${pluralize(diffMonth, 'месяц', 'месяца', 'месяцев')} назад`;
  }
  
  return `${diffYear} ${pluralize(diffYear, 'год', 'года', 'лет')} назад`;
};

/**
 * Russian pluralization helper
 * @param {number} n - Number to pluralize for
 * @param {string} one - Form for 1
 * @param {string} few - Form for 2-4
 * @param {string} many - Form for 5+
 * @returns {string} Correct plural form
 */
export const pluralize = (n, one, few, many) => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  
  if (mod10 === 1 && mod100 !== 11) {
    return one;
  }
  
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return few;
  }
  
  return many;
};

/**
 * Format date to readable string
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return '';
  
  return new Date(date).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

